import styled from 'styled-components';
import { media } from '@prisjakt/ui-base';
import Button from '@prisjakt/ui-button';

const Banner = styled.div`
  display: ${props => (props.show ? 'block' : 'none')};
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  padding: 15px 20px;
  background: rgba(248, 249, 248, 0.95);
  border-style: solid;
  border-color: ${p => p.theme.lines.primary};
  border-width: 1px 0 0 0;
  z-index: 999;

  ${media.smallOnly`
    padding: 10px;
  `}

  p {
    margin: 0;
  }
`;

const BannerContent = styled.div`
  display: flex;
  max-width: 1000px;
  margin-right: auto;
  margin-left: auto;
  flex-direction: row;
  align-items: center;
  flex-wrap: nowrap;
  height: 100%;

  a {
    white-space: nowrap;
  }
`;

const BannerText = styled.div`
  margin-right: 20px;

  a {
    text-decoration: underline;
  }

  ${media.smallOnly`
    padding: 0;
  `}
`;

const PrivacyLinks = styled.p`
  display: flex;
  flex-wrap: wrap;
  align-items: left;

  a {
    margin-top: 7px;
    white-space: normal;
  }
`;

const AcceptButton = styled(Button).attrs({
  'data-test': 'CookieBannerAcceptButton',
})`
  && {
    display: none;
    margin-left: 5px;
    white-space: nowrap;

    ${props => props.desktop && media.mediumUp({ display: 'block' })};
    ${props => props.mobile && media.smallOnly({ display: 'block' })};
  }
`;

export { Banner, BannerContent, BannerText, PrivacyLinks, AcceptButton };
